var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-fullscreen',[_c('login-form',{attrs:{"external-error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }